module.exports = __webpack_public_path__ + "img/nolgong-footer.12225b0c.svg";